import * as Rx from 'rxjs';
import { config } from '../config';
import { Client } from '@stomp/stompjs';
import store from '../store/store';
import { getJwtToken } from '../../authentication/selectors/authetication';
import * as cookies from 'js-cookie';

export default class RestService {

    public restFetch(url: string) {
        return Rx.Observable.create(
            (observer: Rx.Observer<any>) => {
                fetch(config.serverURL + url + '?t=' + new Date().getTime(), {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    }
                }).then((response: Response) => {
                    if (response.status !== 200) {
                        observer.error(response.statusText);
                    }
                    response
                        .text()
                        .then((data: any) => {
                            if (!data) {
                                observer.error('No json input');
                            }
                            try {
                                const parsed = JSON.parse(data);
                                observer.next(parsed);
                            } catch (e) {
                                observer.error(e);
                            }
                        })
                        .catch(error => observer.error(error));
                });
            }
        );
    }
    /**
     * 
     * @param url request url without server host and context path
     * @param request 
     */
    public restPost(url: string, request: any): Rx.Observable<any> {
        const xsrf: any = cookies.get('XSRF-TOKEN');
        return Rx.Observable.create(
            (observer: Rx.Observer<any>) => {
                fetch(config.serverURL + url + '?t=' + new Date().getTime(), {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': xsrf
                    },
                    body: JSON.stringify(request)
                }).then((response: Response) => {
                    response
                        .text()
                        .then((data: any) => {
                            if (!data) {
                                observer.error('No json input');
                            }
                            observer.next(JSON.parse(data));
                        })
                        .catch(error => observer.error(error));
                })
                    .catch(error => observer.error(error));
            }
        );
    }

    public restPostOctetStreamRequest(url: string, request: any, csvName: string): Rx.Observable<any> {
        const xsrf: any = cookies.get('XSRF-TOKEN');
        return Rx.Observable.create(
            (observer: Rx.Observer<any>) => {
                fetch(config.serverURL + url + '?t=' + new Date().getTime(), {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        Accept: 'application/octet-stream',
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': xsrf
                    },
                    body: JSON.stringify(request)
                }).then((response: Response) => {
                    if (response.status !== 200) {
                        observer.error('error.noDataToBeDownloaded');
                    } else {
                        response.blob().then(blob => {
                            const link = document.createElement('a');
                            const browserUrl = URL.createObjectURL(blob);
                            link.href = browserUrl;
                            link.download = `${csvName}.csv`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        });
                        observer.next(csvName);
                    }
                })
                    .catch(error => observer.error(error));
            }
        );
    }
}